/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { Type } from "@adapptio/lib-blueprint";
import { IActionContext, INodeContext, INodeResult } from "../ActionManager";
import { createSuccessNodeResult } from "../helpers";
import { NODE_OUTPUT_NAMES, TAllNodesSpec, TBlueprintStartNodeOptsSchemaSpec } from "../../blueprints";

export async function startNodeHandler<TSpec extends Partial<TAllNodesSpec>>(
	opts: TBlueprintStartNodeOptsSchemaSpec,
	aCtx: IActionContext<TSpec>,
	nCtx: INodeContext
): Promise<INodeResult> {
	return createSuccessNodeResult(
		{
			opts,
			outputName: NODE_OUTPUT_NAMES.ON_START,
			data: null,
			typeDescriptor: Type.Void({})
		},
		aCtx,
		nCtx
	);
}
